/**
 * Pavo yazarkasa KDV grubu (TaxGroupCode) yardımcıları.
 *
 * Cihaz `KDV<oran>` biçimini bekler: KDV0, KDV1, KDV8, KDV10, KDV18, KDV20...
 * Daha önce çağıran tarafta 20/10/8/1 için sabit bir eşleme vardı ve tanınmayan
 * her oran sessizce `KDV0`'a düşüyordu; %18'de kalmış ürünler fişe KDV'siz
 * basılıyordu. Oran artık doğrudan koda çevriliyor.
 *
 * Kritik ayrım: "oran 0" ile "oran çözülemedi" aynı şey değil. Gerçekten KDV'siz
 * ürünler var (bazı gıdalar, kitaplar), bu yüzden 0 geçerli bir orandır. Ancak
 * stok kartı bulunamadığı için oluşan tanımsız değer 0'a çevrilmemeli — aksi
 * halde mali fiş yanlış kesilir. Bu yüzden çözülemeyen değerlerde kod
 * üretilmez ve çağıran işlemi durdurur.
 */

/**
 * Ham değeri fiş kesmeye elverişli bir orana çevirir, çevrilemezse `undefined`.
 *
 * Sayısal metinler de kabul edilir ("20", "%20 hariç" değil ama "20,0" gibi):
 * oran bazı API/localStorage yollarında string olarak dolaşabiliyor ve eski kod
 * bunu tanımadığı için sessizce KDV0'a düşürüyordu.
 */
export const parseVatRate = (value: unknown): number | undefined => {
  const num =
    typeof value === 'number' ? value :
    typeof value === 'string' && value.trim() !== '' ? Number(value.trim().replace(',', '.')) :
    NaN;
  return Number.isFinite(num) && num >= 0 && num <= 100 ? num : undefined;
};

/** %20 → 'KDV20'. Oran çözülemiyorsa null döner. */
export const toTaxGroupCode = (rate: unknown): string | null => {
  const parsed = parseVatRate(rate);
  return parsed === undefined ? null : `KDV${Math.round(parsed)}`;
};

/**
 * Fiş kalemi için KDV grubu kodu üretir, çözülemezse ürün adını içeren
 * anlaşılır bir hata fırlatır.
 */
export const requireTaxGroupCode = (rate: unknown, productName: string): string => {
  const code = toTaxGroupCode(rate);
  if (!code) {
    throw new Error(
      `"${productName}" ürününün KDV oranı belirlenemedi. Fişin KDV'siz kesilmemesi için ` +
      `işlem durduruldu. Lütfen ürünün stok kartındaki KDV oranını kontrol edin.`
    );
  }
  return code;
};